// src/pages/Admin/CatQnATest/CatQnATest.jsx
import React, { useState } from 'react';
import LeadCaptureModal from '../../components/Leads/LeadCaptureModal';
import { CategorySearch } from '../../components/Admin/Category/CategorySearch'; // Correct import


export default function CatQnATest() {
  const [modalOpen, setModalOpen] = useState(false);
  const [categoryId, setCategoryId] = useState(null);

  const handleCategorySelect = (cat) => {
    if (cat && cat.id) {
      setCategoryId(cat.id);
      setModalOpen(true);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Category Q&A Test Page</h1>

      {/* Category Search */}
      <div className="mb-6">
        <CategorySearch onSelect={handleCategorySelect} /> {/* 👈 passes onSelect */}
      </div>

      {/* Q&A Modal */}
      {modalOpen && (
        <LeadCaptureModal
          categoryId={categoryId}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
}
